import SetPasswordStandard from './SetPassword';

type Props = {
  readonly className?: string;
  // eslint-disable-next-line react/boolean-prop-naming
  readonly autoFocus?: boolean;
  readonly onSubmit: (password: string) => Promise<void>;
  readonly errorMessage?: string;
  readonly clearErrorMessage?: () => void;
  readonly maxLength?: number;
};

// UrbexVault (APP-428): always render the two-field form (password + confirm).
// Upstream picks Lite (single field) whenever forgot-password is enabled.
const SetPassword = (props: Props) => <SetPasswordStandard {...props} />;

export default SetPassword;
